// src/design-system/Atoms/Tooltip.tsx
import React from "react";

interface TooltipProps {
    text: string;
    position: { top: number; left: number };
}

const Tooltip: React.FC<TooltipProps> = ({ text, position }) => {
    return (
        <div
            className="fixed z-50 bg-gray-800 text-white text-xs px-2 py-1 rounded shadow"
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
                transform: "translateX(-50%)",
                pointerEvents: "none",
            }}
        >
            {text}
        </div>
    );
};

export default Tooltip;
